class UserDetail {
    constructor({
        _id = "",
        profile_picture = "",
        fcm_token = "",
        is_deleted = false,
        created_at = "",
        updated_at = "",
        name = "",
        email = "",
        password = "",
        device_type = "",
        sub_id = "",
        purchased_on = "",
        expiry_time = "",
        billing = "",
        isSubscribed = "false",
        isVip = "false",
        amount = "",
        interval = "",
        intervalCount = "",
        currency = "",
        status = "",
        product_title = "",
        product_image = "",
        payment_status = "",
        order_number = "",
        totalprojectCount = 0,
        completedProjectCount = 0,
        notStartedProjectCount = 0,
        onGoingProjectCount = 0,
        __v = 0
    }) {
        this._id = _id;
        this.profile_picture = profile_picture;
        this.fcm_token = fcm_token;
        this.is_deleted = is_deleted;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.name = name;
        this.email = email;
        this.password = password;
        this.device_type = device_type;
        this.sub_id = sub_id;
        this.purchased_on = purchased_on;
        this.expiry_time = expiry_time;
        this.billing = billing;
        this.isSubscribed = isSubscribed;
        this.isVip = isVip;
        this.amount = amount;
        this.interval = interval;
        this.intervalCount = intervalCount;
        this.currency = currency;
        this.status = status;
        this.product_title = product_title;
        this.product_image = product_image;
        this.payment_status = payment_status;
        this.order_number = order_number;
        this.totalprojectCount = totalprojectCount;
        this.completedProjectCount = completedProjectCount;
        this.notStartedProjectCount = notStartedProjectCount;
        this.onGoingProjectCount = onGoingProjectCount;
        this.__v = __v;
    }
}

export { UserDetail };
